export default function toggleClass({ classesList, className, removePattern = null, force = null }) {
  const classIndex = classesList.indexOf(className);
  const hasClass = classIndex > -1;
  const addClass = force === null ? !hasClass : force;

  let classes = [...classesList];

  if (removePattern) {
    classes = classes
      .map((c) => c.match(removePattern) ? null : c)
      .filter(c => c);
  }

  if (addClass) {
    classes.push(className);
  } else {
    classes = classes
      .map((c, i) => i === classIndex ? null : c)
      .filter(c => c);
  }

  return classes;
}
